var exports = {
  "j": "MarkdownViewerContainer__nAR3gl",
  "e": "markdownBody__DhGcnT",
};

module.exports = exports;
